export const formatAppPin = (
  prefix: string,
  id?: number | string | null
): string => {
  if (id === undefined || id === null || String(id).length <= 0) {
    return '';
  }

  return `${prefix}${String(id).padStart(5, '0')}`;
};
